export default [
  {
    id: 1,
    title: { it: "Contenitori", en: "Storage units" },
    subTitle: {
      it: "basi in appoggio e sospese",
      en: "sit-on-top and wall-mounted base units",
    },
    products: [
      {
        sourceImage: require("./images/mainImgs/home/04e.jpg"),
        detailImage: "SospeseHome",
        room: "Home",
        code: "04e",
        name: { it: "Soggiorno", en: "Living room" },
        size: {
          height: "19,3 - 37,6 - 55,9 - 74,2 - 110,8",
          widths: "45 - 60 - 75 - 90 - 120",
          depths: "35,4 - 45,4 - 60,6",
        },
      },
      {
        sourceImage: require("./images/mainImgs/home/05b.jpg"),

        detailImage: "SospeseHome",
        room: "Home",
        code: "05b",
        name: { it: "Soggiorno", en: "Living room" },
        size: {
          height: "19,3 - 37,6 - 55,9 - 74,2 - 110,8",
          widths: "45 - 60 - 75 - 90 - 120",
          depths: "35,4 - 45,4 - 60,6",
        },
      },
      {
        sourceImage: require("./images/mainImgs/home/05b.jpg"),

        detailImage: "SospeseHome",
        room: "Home",
        code: "05b",
        name: { it: "Soggiorno", en: "Living room" },
        size: {
          height: "19,3 - 37,6 - 55,9 - 74,2 - 110,8",
          widths: "45 - 60 - 75 - 90 - 120",
          depths: "35,4 - 45,4 - 60,6",
        },
      },
      {
        sourceImage: require("./images/mainImgs/home/07a.jpg"),

        detailImage: "SospeseHome",
        room: "Home",
        code: "07a",
        name: { it: "Soggiorno", en: "Living room" },
        size: {
          height: "19,3 - 37,6 - 55,9 - 74,2 - 110,8",
          widths: "45 - 60 - 75 - 90 - 120",
          depths: "35,4 - 45,4 - 60,6",
        },
      },
      {
        sourceImage: require("./images/mainImgs/public/03c.jpg"),

        detailImage: "SospesePublic",
        room: "Public",
        code: "03c",
        name: { it: "Ufficio operativo", en: "Workspace" },
        size: {
          height: "19,3 - 37,6 - 55,9 - 74,2 - 110,8",
          widths: "45 - 60 - 75 - 90 - 120",
          depths: "35,4 - 45,4 - 60,6",
        },
      },
      {
        sourceImage: require("./images/mainImgs/public/08c.jpg"),

        detailImage: "SospesePublic",
        room: "Public",
        code: "08c",
        name: { it: "Spazi comuni", en: "Common areas" },
        size: {
          height: "19,3 - 37,6 - 55,9 - 74,2 - 110,8",
          widths: "45 - 60 - 75 - 90 - 120",
          depths: "35,4 - 45,4 - 60,6",
        },
      },
      {
        sourceImage: require("./images/mainImgs/public/09a.jpg"),

        detailImage: "SospesePublic",
        room: "Public",
        code: "09a",
        name: { it: "Spazi comuni", en: "Common areas" },
        size: {
          height: "19,3 - 37,6 - 55,9 - 74,2 - 110,8",
          widths: "45 - 60 - 75 - 90 - 120",
          depths: "35,4 - 45,4 - 60,6",
        },
      },
      {
        sourceImage: require("./images/mainImgs/public/17b.jpg"),

        detailImage: "SospesePublic",
        room: "Public",
        code: "17b",
        name: { it: "Bistrot", en: "Bistro" },
        size: {
          height: "19,3 - 37,6 - 55,9 - 74,2 - 110,8",
          widths: "45 - 60 - 75 - 90 - 120",
          depths: "35,4 - 45,4 - 60,6",
        },
      },
    ],
  },
  {
    id: 2,
    title: { it: "Contenitori", en: "Storage units" },
    subTitle: { it: "basi a terra", en: "floorstanding base units" },
    products: [
      {
        sourceImage: require("./images/mainImgs/home/04c.jpg"),
        detailImage: "ATerraHome",
        room: "Home",
        code: "04c",
        name: { it: "Soggiorno", en: "Living room" },
        size: {
          height: "20 - 38,3 - 56,6 - 74,9 - 111,5",
          widths: "45 - 60 - 75 - 90 - 120",
          depths: "35,5 - 45,5 - 60,6",
        },
      },
      {
        sourceImage: require("./images/mainImgs/home/05d.jpg"),

        detailImage: "ATerraHome",
        room: "Home",
        code: "05d",
        name: { it: "Soggiorno", en: "Living room" },
        size: {
          height: "20 - 38,3 - 56,6 - 74,9 - 111,5",
          widths: "45 - 60 - 75 - 90 - 120",
          depths: "35,5 - 45,5 - 60,6",
        },
      },
      {
        sourceImage: require("./images/mainImgs/public/03b.jpg"),

        detailImage: "ATerraPublic",
        room: "Public",
        code: "03b",
        name: { it: "Ufficio operativo", en: "Workspace" },
        size: {
          height: "20 - 38,3 - 56,6 - 74,9 - 111,5",
          widths: "45 - 60 - 75 - 90 - 120",
          depths: "35,5 - 45,5 - 60,6",
        },
      },
      {
        sourceImage: require("./images/mainImgs/public/06c.jpg"),

        detailImage: "ATerraPublic",
        room: "Public",
        code: "06c",
        name: { it: "Ufficio open space", en: "Open-plan office" },
        size: {
          height: "20 - 38,3 - 56,6 - 74,9 - 111,5",
          widths: "45 - 60 - 75 - 90 - 120",
          depths: "35,5 - 45,5 - 60,6",
        },
      },
    ],
  },
  {
    id: 3,
    title: { it: "Contenitori", en: "Storage units" },
    subTitle: {
      it: "pensili",
      en: "wall units",
    },
    products: [
      {
        sourceImage: require("./images/mainImgs/home/05d.jpg"),
        detailImage: "PensiliHome",
        room: "Home",
        code: "05d",
        name: { it: "Soggiorno", en: "Living room" },
        size: {
          height: "36,6 - 54,9 - 73,2 - 91,5",
          widths: "30 - 45 - 60 - 75 - 90 - 120",
          depths: "35,4",
        },
      },
      {
        sourceImage: require("./images/mainImgs/home/06c.jpg"),

        detailImage: "PensiliHome",
        room: "Home",
        code: "06c",
        name: { it: "Soggiorno", en: "Living room" },
        size: {
          height: "36,6 - 54,9 - 73,2 - 91,5",
          widths: "30 - 45 - 60 - 75 - 90 - 120",
          depths: "35,4",
        },
      },
      {
        sourceImage: require("./images/mainImgs/home/06c.jpg"),

        detailImage: "PensiliHome",
        room: "Home",
        code: "06c",
        name: { it: "Camera", en: "Bedroom" },
        size: {
          height: "36,6 - 54,9 - 73,2 - 91,5",
          widths: "30 - 45 - 60 - 75 - 90 - 120",
          depths: "35,4",
        },
      },
      {
        sourceImage: require("./images/mainImgs/public/13a.jpg"),

        detailImage: "PensiliPublic",
        room: "Public",
        code: "13a",
        name: { it: "Direzionale", en: "Executive space" },
        size: {
          height: "36,6 - 54,9 - 73,2 - 91,5",
          widths: "30 - 45 - 60 - 75 - 90 - 120",
          depths: "35,4",
        },
      },
      {
        sourceImage: require("./images/mainImgs/public/13a.jpg"),

        detailImage: "PensiliPublic",
        room: "Public",
        code: "13a",
        name: { it: "Aparthotel", en: "Serviced apartament" },
        size: {
          height: "36,6 - 54,9 - 73,2 - 91,5",
          widths: "30 - 45 - 60 - 75 - 90 - 120",
          depths: "35,4",
        },
      },
    ],
  },
  {
    id: 3,
    title: { it: "Contenitori", en: "Storage units" },
    subTitle: {
      it: "pensili",
      en: "wall units",
    },
    products: [
      {
        sourceImage: require("./images/mainImgs/home/05d.jpg"),
        detailImage: "PensiliHome",
        room: "Home",
        code: "05d",
        name: { it: "Soggiorno", en: "Living room" },
        size: {
          height: "36,6 - 54,9 - 73,2 - 91,5",
          widths: "30 - 45 - 60 - 75 - 90 - 120",
          depths: "35,4",
        },
      },
      {
        sourceImage: require("./images/mainImgs/home/06c.jpg"),

        detailImage: "PensiliHome",
        room: "Home",
        code: "06c",
        name: { it: "Soggiorno", en: "Living room" },
        size: {
          height: "36,6 - 54,9 - 73,2 - 91,5",
          widths: "30 - 45 - 60 - 75 - 90 - 120",
          depths: "35,4",
        },
      },
      {
        sourceImage: require("./images/mainImgs/home/06c.jpg"),

        detailImage: "PensiliHome",
        room: "Home",
        code: "06c",
        name: { it: "Camera", en: "Bedroom" },
        size: {
          height: "36,6 - 54,9 - 73,2 - 91,5",
          widths: "30 - 45 - 60 - 75 - 90 - 120",
          depths: "35,4",
        },
      },
      {
        sourceImage: require("./images/mainImgs/public/13a.jpg"),

        detailImage: "PensiliPublic",
        room: "Public",
        code: "13a",
        name: { it: "Direzionale", en: "Executive space" },
        size: {
          height: "36,6 - 54,9 - 73,2 - 91,5",
          widths: "30 - 45 - 60 - 75 - 90 - 120",
          depths: "35,4",
        },
      },
      {
        sourceImage: require("./images/mainImgs/public/13a.jpg"),

        detailImage: "PensiliPublic",
        room: "Public",
        code: "13a",
        name: { it: "Aparthotel", en: "Serviced apartament" },
        size: {
          height: "36,6 - 54,9 - 73,2 - 91,5",
          widths: "30 - 45 - 60 - 75 - 90 - 120",
          depths: "35,4",
        },
      },
    ],
  },
  {
    id: 4,
    title: { it: "Contenitori", en: "Storage units" },
    subTitle: {
      it: "casellari",
      en: "shelving units",
    },
    products: [
      {
        sourceImage: require("./images/mainImgs/home/04c1.jpg"),
        detailImage: "PensiliHome",
        room: "Home",
        code: "04c",
        name: { it: "Soggiorno", en: "Living room" },
        size: {
          height: "36,6 - 54,9 - 73,2",
          widths: "30 - 45 - 60 - 75 - 90",
          depths: "25 - 33",
        },
      },
      {
        sourceImage: require("./images/mainImgs/home/06b.jpg"),

        detailImage: "PensiliHome",
        room: "Home",
        code: "06b",
        name: { it: "Soggiorno", en: "Living room" },
        size: {
          height: "36,6 - 54,9 - 73,2",
          widths: "30 - 45 - 60 - 75 - 90",
          depths: "25 - 33",
        },
      },
      {
        sourceImage: require("./images/mainImgs/public/03b.jpg"),

        detailImage: "PensiliPublic",
        room: "Public",
        code: "03b",
        name: { it: "Operativo", en: "Workspace" },
        size: {
          height: "36,6 - 54,9 - 73,2",
          widths: "30 - 45 - 60 - 75 - 90",
          depths: "25 - 33",
        },
      },
      {
        sourceImage: require("./images/mainImgs/public/17a.jpg"),

        detailImage: "PensiliPublic",
        room: "Public",
        code: "17a",
        name: { it: "Bistrot", en: "Bistro" },
        size: {
          height: "36,6 - 54,9 - 73,2",
          widths: "30 - 45 - 60 - 75 - 90",
          depths: "25 - 33",
        },
      },
    ],
  },
];
